<template>
  <div class="member-date-filter">
    <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      :return-value.sync="dateOfRegisterFilter"
      transition="scale-transition"
      offset-y
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="dateOnButton"
          background-color="white"
          :placeholder="buttonPlaceholder"
          outlined
          dense
          readonly
          v-bind="attrs"
          v-on="on"
        >
          <template v-slot:append>
            <div class="w-20px h-20px d-flex justify-center align-center pt-1">
              <v-icon style="font-size: 20px">{{ appendIcon }}</v-icon>
            </div>
          </template>
        </v-text-field>
      </template>
      <v-date-picker
        v-model="dateOfRegisterFilter"
        color="brand-500"
        range
        :width="modalWidth"
      >
        <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
        <v-btn text color="primary" @click="okHandler">OK</v-btn>
      </v-date-picker>
    </v-menu>
  </div>
</template>

<script>
// Zeplin: https://app.zeplin.io/project/5f092773fa16ac9ddd3d2a2f/screen/5f2d72564729061eca5595c7
// Doc: https://vuetifyjs.com/en/components/date-pickers/#month-pickers-in-dialog-and-menu
// Doc: https://vuetifyjs.com/en/components/menus/#menus
// Doc: https://vuetifyjs.com/en/components/text-fields/#api

export default {
  props: {
    modalWidth: {
      type: [String, Number],
      default: '290px',
    },
    buttonPlaceholder: {
      type: String,
      default: '篩選註冊日期區間',
    },
    appendIcon: {
      type: String,
      default: 'arrow_drop_down',
    },
  },
  data() {
    return {
      menu: '',
      dateOfRegisterFilter: [],
    };
  },
  computed: {
    dateOnButton() {
      if (this.dateOfRegisterFilter.length === 0) {
        return '';
      }
      if (this.dateOfRegisterFilter.length === 1) {
        return this.dateOfRegisterFilter[0].replace(/-/g, '.');
      }

      const fromDate = this.dateOfRegisterFilter[0].replace(/-/g, '.');
      const toDate = this.dateOfRegisterFilter[1].replace(/-/g, '.');
      return `${fromDate}-${toDate}`;
    },
  },
  methods: {
    okHandler() {
      this.$refs.menu.save(this.dateOfRegisterFilter);
      this.$emit('update:dateOfRegisterFilter', this.dateOfRegisterFilter);
    },
  },
};
</script>

<style lang="scss">
.member-date-filter {
  // border
  fieldset {
    border-color: #d7dee7;
  }
  .v-input--is-focused {
    border-color: $brand-500;
  }
  // placeholder
  .v-text-field__slot input::placeholder {
    color: #848fa0;
    font-size: 14px;
  }
  .v-text-field__details {
    display: none;
  }
}
</style>
